"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _FoodMenu = require("../../../FoodMenu.context");

var _index = require("../index");

var _menu = _interopRequireDefault(require("../../../utils/menu"));

var _MenuItemCartModal = _interopRequireDefault(require("../../../../MenuItemCartModal"));

require("./Item.css");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var ItemContainer = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(ItemContainer, _React$Component);

  var _super = _createSuper(ItemContainer);

  function ItemContainer(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, ItemContainer);
    _this = _super.call(this, props);
    _this.state = {
      modalOpen: false
    };
    _this.handleOpen = _this.handleOpen.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleClose = _this.handleClose.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getModalOpen = _this.getModalOpen.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(ItemContainer, [{
    key: "handleOpen",
    value: function handleOpen() {
      this.setState({
        modalOpen: true
      });
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.setState({
        modalOpen: false
      });
    }
  }, {
    key: "getModalOpen",
    value: function getModalOpen() {
      return this.state.modalOpen;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var itemId = this.props.itemId;
      return /*#__PURE__*/_react["default"].createElement(_FoodMenu.MenuConsumer, null, function (_ref) {
        var items = _ref.items,
            modifierSets = _ref.modifierSets,
            modifiers = _ref.modifiers;

        var item = _menu["default"].getItemById(items, itemId);

        var _id = item._id,
            name = item.name,
            description = item.description,
            image = item.image,
            _item$available = item.available,
            available = _item$available === void 0 ? true : _item$available,
            restItem = (0, _objectWithoutProperties2["default"])(item, ["_id", "name", "description", "image", "available"]);
        var itemModifierSetIds = item.modifierSets;

        var itemModifierSets = _menu["default"].getItemModifierSets(itemModifierSetIds, modifierSets);

        return /*#__PURE__*/_react["default"].createElement(_FoodMenu.VariantConsumer, null, function (_ref2) {
          var itemDisplay = _ref2.itemDisplay;
          var ItemComponent = _index.displayVariantComponentMap.item[itemDisplay];
          return /*#__PURE__*/_react["default"].createElement(_FoodMenu.CartConsumer, null, function (cart) {
            if (cart === false) {
              return /*#__PURE__*/_react["default"].createElement(ItemComponent, (0, _extends2["default"])({
                isSingleVariation: _menu["default"].menuItemHasOneVariation(item),
                id: _id,
                name: name,
                description: description,
                image: image,
                variations: _menu["default"].getMenuItemVariations(item)
              }, restItem));
            }

            return /*#__PURE__*/_react["default"].createElement(_MenuItemCartModal["default"], {
              trigger: /*#__PURE__*/_react["default"].createElement(ItemComponent, (0, _extends2["default"])({
                className: !available && 'fcfm-menu-item-disabled',
                onClick: available ? _this2.handleOpen : function () {
                  return null;
                },
                isSingleVariation: _menu["default"].menuItemHasOneVariation(item),
                id: _id,
                name: name,
                description: description,
                image: image,
                variations: _menu["default"].getMenuItemVariations(item)
              }, restItem)),
              open: _this2.getModalOpen(),
              onClose: _this2.handleClose,
              item: item,
              modifiers: modifiers,
              modifierSets: itemModifierSets,
              variations: _menu["default"].getMenuItemVariations(item),
              cart: cart
            });
          });
        });
      });
    }
  }]);
  return ItemContainer;
}(_react["default"].Component);

var _default = ItemContainer;
exports["default"] = _default;